import { createFileRoute } from '@tanstack/react-router';

import { LanguageSettingsPage } from '~/features/account/language-settings-page';

export const Route = createFileRoute('/_app/account/language')({
  component: LanguageSettingsPage,
});
